<template>
  <div class="f-tag-field f-tag-field--lg">
    <div class="f-tag-field__tags">
      <div
        v-for="(tag, idx) in modelValue"
        :key="tag"
        :data-tag="tag"
        :draggable="true"
        class="f-tag-field__tag"
      >
        <span>
          {{ tag }}
        </span>
        <button
          type="button"
          class="f-tag-field__tag-remove"
          :aria-label="$t('actions.remove')"
          @click="removeTag(idx)"
        />
      </div>
      <input
        ref="input"
        v-model="currentText"
        type="text"
        class="f-tag-field__input"
        :placeholder="modelValue.length > 0 ? '' : placeholder"
        @keypress.enter="addTag"
        @input="validate"
      >
      <Transition name="validation-fade">
        <p
          v-if="error && error.message"
          class="f-field__validation u-text-danger"
        >
          {{ error.message }}
        </p>
      </Transition>
    </div>
    <div class="f-tag-field__hint subject-field__hint">
      <span>
        {{ $t(`advancedsearch.fields.${fieldName}.hint`) }}
      </span>
      <svg
        width="25"
        height="18"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g
          fill="none"
          fill-rule="evenodd"
        >
          <rect
            stroke="var(--gray-400)"
            fill="var(--light-gray-300)"
            x=".5"
            y=".5"
            width="24"
            height="17"
            rx="2"
          />
          <g
            stroke="var(--gray)"
            stroke-linecap="round"
            stroke-width="1.2"
          >
            <path
              stroke-linejoin="round"
              d="M8 10.5h9v-4h-3"
            />
            <path d="M10 12.5l-2-2 2-2" />
          </g>
        </g>
      </svg>
    </div>
  </div>
</template>

<script>
import { MetadataUtils } from '@scholar/metadata-utils/main'

export default {
  props: {
    modelValue: {
      type: Array,
      required: true
    },
    recordType: {
      type: String,
      required: true
    },
    fieldName: {
      type: String,
      required: true
    },
    validatorName: {
      type: String,
      default: null
    },
    isRequired: {
      type: Boolean,
      default: false
    },
    array: {
      type: Boolean,
      required: true
    }
  },
  emits: ['change'],
  data() {
    return {
      currentText: '',
      validation: { status: true },
      parser: new MetadataUtils().getParserByType(this.recordType)
    }
  },
  computed: {
    placeholder() {
      if (this.$te(`advancedsearch.fields.${this.fieldName}.placeholder`)) {
        return this.$t(`advancedsearch.fields.${this.fieldName}.placeholder`)
      } else {
        return this.$t(`fields.record.${this.fieldName}.placeholder`)
      }
    },
    error() {
      return this.validation.status ? {} : { type: 'danger', message: this.$t(`forms.fields.errors.metadata-utils.${this.validation?.field?.error}`) }
    }
  },
  methods: {
    async addTag() {
      if (this.currentText === '') {
        return
      }
      const isValid = !(this.error && this.error.message)
      if (!this.modelValue.includes(this.currentText) && isValid) {
        this.modelValue.push(this.currentText)
      }
      if (isValid) {
        this.currentText = ''
      }
      this.$emit('change', this.modelValue)
    },
    removeTag(idx) {
      this.modelValue.splice(idx, 1)
      this.$refs.input.focus()
      this.$emit('change', this.modelValue)
    },
    async validate() {
      if (this.currentText === '' || this.validatorName.startsWith('fundingReferences')) {
        // HACK: Funding reference fields do not have individual validators
        this.validation.status = true
      } else {
        const val = this.array ? [this.currentText] : this.currentText
        this.validation = await this.parser.validateByField(this.validatorName || this.fieldName, val)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.subject-field__hint {
  span + svg {
    margin-left: 0.5rem;
  }
}
</style>
